import type { IntegrationHealthState, IntegrationRun } from '../api/dataApi';

// Presentation copy for the Phase 2 health states (backend
// internal/integrationrun). Health is DERIVED and separate from lifecycle
// (Configured / Paused / ...): a quiet webhook is never shown as unhealthy.
export const healthCopy: Record<IntegrationHealthState, { label: string; description: string }> = {
  healthy: { label: 'Healthy', description: 'Data is arriving and being processed.' },
  waiting: { label: 'Waiting for data', description: 'Nothing has been delivered yet.' },
  no_recent: { label: 'No recent events', description: 'Quiet for a while - normal for an event-driven source.' },
  delayed: { label: 'Delayed', description: 'A source that runs on a schedule is overdue.' },
  attention: { label: 'Needs attention', description: 'Deliveries are failing or credentials are being rejected.' },
};

export const runStatusLabel: Record<IntegrationRun['status'], string> = {
  success: 'Success',
  empty: 'No output',
  failed: 'Failed',
};

export const runSourceLabel: Record<string, string> = {
  webhook: 'Webhook',
  prometheus_remote_write: 'Remote write',
  agent: 'Agent',
};

export function formatRunTime(ms: number): string {
  if (!ms) return '—';
  return new Date(ms).toLocaleString(undefined, { dateStyle: 'medium', timeStyle: 'short' });
}

// "3 in, 2 out" / "3 in, 2 out, 1 dropped".
export function describeRunCounts(run: Pick<IntegrationRun, 'inputCount' | 'signalCount' | 'rejectedCount'>): string {
  const parts = [`${run.inputCount} in`, `${run.signalCount} out`];
  if (run.rejectedCount > 0) parts.push(`${run.rejectedCount} dropped`);
  return parts.join(', ');
}

export function relativeAgo(ms: number, now = Date.now()): string {
  if (!ms) return 'never';
  const s = Math.max(0, Math.round((now - ms) / 1000));
  if (s < 60) return 'just now';
  if (s < 3600) return `${Math.floor(s / 60)} min ago`;
  if (s < 86400) return `${Math.floor(s / 3600)} h ago`;
  return `${Math.floor(s / 86400)} d ago`;
}
